export function installFetchInterceptor(): void {
  const _fetch = window.fetch.bind(window);
  window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const url =
      input instanceof URL
        ? input.href
        : typeof input === "string"
        ? input
        : (input as Request).url;
    if (url.startsWith("/api/v2/")) {
      const token = localStorage.getItem("syntrofi_jwt");
      if (token) {
        let existingHeaders: Record<string, string> = {};
        if (init?.headers) {
          if (init.headers instanceof Headers) {
            init.headers.forEach((v, k) => {
              existingHeaders[k] = v;
            });
          } else if (Array.isArray(init.headers)) {
            for (const [k, v] of init.headers) {
              existingHeaders[k] = v;
            }
          } else {
            existingHeaders = init.headers as Record<string, string>;
          }
        }
        init = { ...init, headers: { Authorization: `Bearer ${token}`, ...existingHeaders } };
      }
    }
    return _fetch(input, init);
  };
}
